import axios from "axios";
import router from "../router/index";
import { MessageBox, Message } from "element-ui";
// import router from '../router'
// 引入路由是为了做重定向，比如没有登录过期定向到登录页面
// 创建axios实例
// const url = process.env.NODE_ENV === 'development' ? '/api' : 'http://ucasstar.sie.ac.cn/api'
const url = process.env.NODE_ENV === 'development' ?  'http://ucasstar.cn/api' : 'http://ucasstar.cn/api'
// const url =
//   process.env.NODE_ENV === "development"
//     ? "http://43.138.115.155:8011"
//     : "http://43.138.115.155:8011";
const instance = axios.create({
  baseURL: url, // api的base_url(请求的基地址)
  timeout: 3600000, // 请求超时时间
  headers: {
    "content-type": "application/json;charset=UTF-8",
  },
});

// 拦截请求

instance.interceptors.request.use(
  (config) => {
    //  可以在此处添加 token
    if (config.url.indexOf("/c") !== -1) {
      if (localStorage.getItem("token_c")) {
        config.headers.Authorization = localStorage.getItem("token_c");
      }
    } else {
      if (localStorage.getItem("token_b")) {
        config.headers.Authorization = localStorage.getItem("token_b");
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// 拦截响应
instance.interceptors.response.use(
  (res) => {
    // 可以在此处拦截接口错误
    return res;
  },
  (error) => {
    if (error.response.status === 401) {
      console.log(error.response.config.url);
      if (error.response.config.url.indexOf("/c") != -1) {
        localStorage.removeItem("username_c");
        localStorage.removeItem("phone_c");
        localStorage.removeItem("email_c");
        localStorage.removeItem("token_c");
        router.push({ path: "/home" });
      } else {
        localStorage.removeItem("username_b");
        localStorage.removeItem("token_b");
        localStorage.removeItem("userType_b");
        localStorage.removeItem("value");
        localStorage.removeItem("index");
        localStorage.removeItem("progressNow");
        router.push({ path: "/login_b" });
      }
    }
    Message({
      showClose: true,
      message: error.response.data.message, //弹出失败原因
      type: "error",
    });
    return Promise.reject(error);
  }
);
export default instance;
